import arrayToList from './arrayToList'

const getByline = storyAuthors => `By ${ arrayToList( storyAuthors, 'username' ) }`

export default getByline
